/*
 * Palpa — Cotizador automático
 * Calcula el precio en vivo a partir de tramos por cantidad definidos en el
 * personalizador de Shopify, y vuelca el resumen en campos ocultos para que
 * viaje en el email del formulario de contacto.
 */
(function () {
  'use strict';

  /* Convierte "18,75", "1.234,56", "€ 605" -> Number */
  function parseNumber(raw) {
    if (raw === null || raw === undefined) return NaN;
    var s = String(raw).replace(/[^\d.,-]/g, '').trim();
    if (!s) return NaN;
    if (s.indexOf('.') !== -1 && s.indexOf(',') !== -1) {
      // Formato europeo: punto = miles, coma = decimal
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (s.indexOf(',') !== -1) {
      s = s.replace(',', '.');
    }
    var n = parseFloat(s);
    return isNaN(n) ? NaN : n;
  }

  /*
   * Interpreta los tramos escritos en el personalizador. Una línea por tramo:
   *   0-80 = 18,75
   *   81-240 = 17,50
   *   2001-10000 = 13,75
   *   10001+ = 12,00      (también acepta ">10000" y "500>")
   */
  function parseTiers(raw) {
    if (!raw) return [];
    return String(raw)
      .split(/\r?\n/)
      .map(function (line) {
        return line.trim();
      })
      .filter(function (line) {
        return line && line.charAt(0) !== '#';
      })
      .map(function (line) {
        var parts = line.split(/[=|:]/);
        if (parts.length < 2) return null;
        var price = parseNumber(parts.slice(1).join('='));
        if (isNaN(price)) return null;

        var range = parts[0].replace(/\s| /g, '').replace(/[–—]/g, '-');
        var min = 0;
        var max = Infinity;
        var m;

        if ((m = range.match(/^(\d+)-(\d+)$/))) {
          min = parseInt(m[1], 10);
          max = parseInt(m[2], 10);
        } else if ((m = range.match(/^(\d+)\+$/))) {
          min = parseInt(m[1], 10);
        } else if ((m = range.match(/^>=(\d+)$/))) {
          min = parseInt(m[1], 10);
        } else if ((m = range.match(/^>(\d+)$/))) {
          min = parseInt(m[1], 10) + 1;
        } else if ((m = range.match(/^(\d+)>$/))) {
          min = parseInt(m[1], 10) + 1;
        } else if ((m = range.match(/^(\d+)$/))) {
          max = parseInt(m[1], 10);
        } else {
          return null;
        }
        return { min: min, max: max, price: price };
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return a.min - b.min;
      });
  }

  /*
   * Tabla de bolsas para productos que se envían en cantidades cerradas.
   * Una línea por bolsa, con el precio TOTAL de esa cantidad:
   *   25 = 136,13
   *   50 = 245,03
   *   75 = 367,54
   */
  function parsePacks(raw) {
    if (!raw) return [];
    return String(raw)
      .split(/\r?\n/)
      .map(function (line) {
        return line.trim();
      })
      .filter(function (line) {
        return line && line.charAt(0) !== '#';
      })
      .map(function (line) {
        var parts = line.split(/[=|:]/);
        if (parts.length < 2) return null;
        var qty = parseInt(String(parts[0]).replace(/\D/g, ''), 10);
        var price = parseNumber(parts.slice(1).join('='));
        if (!qty || isNaN(price)) return null;
        return { qty: qty, price: price };
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return a.qty - b.qty;
      });
  }

  /*
   * Se cotiza la primera bolsa que alcanza la cantidad pedida: 40 uds -> 50,
   * 270 uds -> 275. Si se pasa de la última fila de la tabla, extrapolamos con
   * su precio unitario redondeando hacia arriba al paso de la tabla.
   */
  function packFor(packs, qty) {
    if (!packs.length) return null;
    for (var i = 0; i < packs.length; i++) {
      if (qty <= packs[i].qty) return { qty: packs[i].qty, price: packs[i].price };
    }
    var last = packs[packs.length - 1];
    var step = packs.length > 1 ? last.qty - packs[packs.length - 2].qty : last.qty;
    if (step <= 0) step = last.qty;
    var billed = Math.ceil(qty / step) * step;
    return { qty: billed, price: (last.price / last.qty) * billed };
  }

  /* Redondea a la decena más cercana: 987 -> 990, 1743 -> 1740 */
  function roundToTen(value) {
    return Math.round(value / 10) * 10;
  }

  /* Tramo aplicable a una cantidad; si se pasa del último, usa el último. */
  function tierFor(tiers, qty) {
    if (!tiers.length) return null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].min && qty <= tiers[i].max) return tiers[i];
    }
    return qty > tiers[tiers.length - 1].max ? tiers[tiers.length - 1] : tiers[0];
  }

  if (customElements.get('palpa-cotizador')) return;

  customElements.define(
    'palpa-cotizador',
    class PalpaCotizador extends HTMLElement {
      connectedCallback() {
        this.currency = this.dataset.currency || 'EUR';
        this.locale = this.dataset.locale || 'es-ES';
        this.defaultOnlinePrice = parseNumber(this.dataset.defaultOnlinePrice);
        this.defaultTiers = parseTiers(this.dataset.defaultTiers);
        this.consultLabel = this.dataset.consultLabel || 'A consultar';
        // Por defecto el resumen es un listado sin importes: la cotización se
        // envía después por email. Se activa desde el personalizador.
        this.showPrices = this.dataset.showPrices === 'true';

        try {
          this.formatter = new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.formatterRound = new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });
        } catch (e) {
          this.formatter = null;
          this.formatterRound = null;
        }

        this.dispositivoTitle = this.dataset.dispositivoTitle || 'Dispositivo';
        this.dispositivoTiers = parseTiers(this.dataset.dispositivoTiers);

        this.interesInputs = this.querySelectorAll('[data-interes]');
        this.steps = this.querySelectorAll('[data-step-for]');

        this.formacionChecks = this.querySelectorAll('[data-formacion]');
        this.numFormaciones = this.querySelector('[data-num-formaciones]');
        this.modalidadInputs = this.querySelectorAll('[data-modalidad]');
        this.asistentes = this.querySelector('[data-asistentes]');
        this.asistentesField = this.querySelector('[data-asistentes-field]');

        this.dispositivoInputs = this.querySelectorAll('[data-dispositivo]');

        this.regaloInputs = this.querySelectorAll('[data-regalo]');

        this.referralOtro = this.querySelector('[data-referral-otro]');
        this.referralOtroField = this.querySelector('[data-referral-otro-field]');
        this.referralOtroInput = this.querySelector('[data-referral-otro-input]');

        this.linesEl = this.querySelector('[data-summary-lines]');
        this.emptyEl = this.querySelector('[data-summary-empty]');
        this.totalEl = this.querySelector('[data-summary-total]');
        this.hiddenSummary = this.querySelector('[data-hidden-summary]');
        this.hiddenTotal = this.querySelector('[data-hidden-total]');

        this.addEventListener('change', this.update.bind(this));
        this.addEventListener('input', this.update.bind(this));

        this.update();
      }

      /* Sin decimales cuando el importe es redondo; con 2 cuando los tiene */
      money(value) {
        var hasCents = Math.abs(value - Math.round(value)) > 0.005;
        if (this.formatter) {
          return hasCents ? this.formatter.format(value) : this.formatterRound.format(value);
        }
        return (
          (hasCents ? value.toFixed(2).replace('.', ',') : String(Math.round(value))) +
          ' ' +
          this.currency
        );
      }

      /* Todos los importes son estimados: se muestran con ~ delante */
      approx(value) {
        return '~' + this.money(value);
      }

      checkedValue(nodeList) {
        for (var i = 0; i < nodeList.length; i++) {
          if (nodeList[i].checked) return nodeList[i].value;
        }
        return '';
      }

      /* ¿Está marcado «Formación», «Dispositivo» o «Regalos corporativos»? */
      quiere(interes) {
        for (var i = 0; i < this.interesInputs.length; i++) {
          if (this.interesInputs[i].dataset.interes === interes) {
            return this.interesInputs[i].checked;
          }
        }
        return false;
      }

      /*
       * Un paso oculto deshabilita todos sus campos: así no viajan vacíos en el
       * email y, sobre todo, sus «required» no bloquean el envío (el navegador
       * no valida controles deshabilitados, pero sí los ocultos, y entonces
       * falla en silencio con «campo no enfocable»).
       */
      setStepActive(step, active) {
        step.hidden = !active;
        step.querySelectorAll('input, select, textarea').forEach(function (el) {
          el.disabled = !active;
        });
      }

      /* Casillas de formación marcadas, en el orden en que aparecen */
      formacionesElegidas() {
        var chosen = [];
        for (var i = 0; i < this.formacionChecks.length; i++) {
          if (this.formacionChecks[i].checked) chosen.push(this.formacionChecks[i]);
        }
        return chosen;
      }

      /*
       * Al menos una temática marcada. El patrón estándar para exigir un grupo
       * de casillas es poner «required» en todas mientras no haya ninguna
       * marcada, y quitarlo en cuanto se marca una.
       */
      syncFormaciones(wantsFormacion) {
        var falta = wantsFormacion && this.formacionesElegidas().length === 0;
        for (var i = 0; i < this.formacionChecks.length; i++) {
          this.formacionChecks[i].required = falta;
        }
      }

      /* Mismo patrón para exigir al menos un «¿Qué estás buscando?» */
      syncInteres() {
        var falta = true;
        for (var i = 0; i < this.interesInputs.length; i++) {
          if (this.interesInputs[i].checked) falta = false;
        }
        for (var j = 0; j < this.interesInputs.length; j++) {
          this.interesInputs[j].required = falta;
        }
      }

      /*
       * Procedencia: los radios llevan «required» fijo desde el Liquid, así que
       * aquí sólo abrimos el campo libre mientras «Otro» siga elegido.
       */
      syncReferral() {
        if (!this.referralOtroField) return;
        var show = !!(this.referralOtro && this.referralOtro.checked);
        this.referralOtroField.hidden = !show;
        if (this.referralOtroInput) {
          this.referralOtroInput.disabled = !show;
          this.referralOtroInput.required = show;
        }
      }

      /*
       * Una sola línea con todas las temáticas elegidas, el nº de sesiones, la
       * modalidad y los asistentes. Ej.: «2 formaciones · Cáncer de mama,
       * Cáncer de piel · Presencial · 40 asistentes».
       */
      formacionLine() {
        if (!this.quiere('formacion')) return null;

        var elegidas = this.formacionesElegidas();
        if (!elegidas.length) return null;

        var modalidad = this.checkedValue(this.modalidadInputs) || 'presencial';

        var sesiones = parseInt(this.numFormaciones && this.numFormaciones.value, 10);
        if (isNaN(sesiones) || sesiones < 1) sesiones = 0;

        var personas = parseInt(this.asistentes && this.asistentes.value, 10);
        if (isNaN(personas) || personas < 0) personas = 0;

        var titulos = elegidas.map(function (el) {
          return el.value;
        });

        var line = {
          title: sesiones
            ? sesiones + (sesiones === 1 ? ' formación' : ' formaciones')
            : 'Formación',
          details: [titulos.join(', ')],
          amount: null,
        };

        var contexto = modalidad === 'online' ? 'Online' : 'Presencial';
        if (personas > 0) contexto += ' · ' + personas + ' asistentes';
        else contexto += ' · indica el nº de asistentes';
        if (!sesiones) contexto += ' · indica el nº de formaciones';
        line.details.push(contexto);

        if (!this.showPrices) return line;

        // Con precios activados cotizamos cada sesión al mismo tramo y lo
        // multiplicamos por el nº de sesiones. Si hay varias temáticas usamos
        // los tramos de la primera que defina los suyos.
        var sesionesCobradas = sesiones || 1;

        if (modalidad === 'online') {
          var online = NaN;
          for (var i = 0; i < elegidas.length && isNaN(online); i++) {
            online = parseNumber(elegidas[i].dataset.onlinePrice);
          }
          if (isNaN(online)) online = this.defaultOnlinePrice;
          // El precio online es cerrado: se muestra tal cual se configura (605 €)
          if (!isNaN(online)) line.amount = online * sesionesCobradas;
          return line;
        }

        if (!personas) return line;

        var tiers = [];
        for (var j = 0; j < elegidas.length && !tiers.length; j++) {
          tiers = parseTiers(elegidas[j].dataset.tiers);
        }
        if (!tiers.length) tiers = this.defaultTiers;
        var tier = tierFor(tiers, personas);
        // Subtotal redondeado a la decena: 677,60 -> 680 · 738,10 -> 740 · 859,10 -> 860
        if (tier) line.amount = roundToTen(tier.price) * sesionesCobradas;
        return line;
      }

      dispositivoQtyInput(input) {
        var card = input.closest('[data-dispositivo-card]');
        return card ? card.querySelector('[data-dispositivo-qty]') : null;
      }

      /*
       * Los formatos son excluyentes, así que sólo la tarjeta elegida muestra y
       * habilita su cantidad: las demás no viajan en el email.
       */
      syncDispositivo(wantsDispositivo) {
        for (var i = 0; i < this.dispositivoInputs.length; i++) {
          var input = this.dispositivoInputs[i];
          var active = wantsDispositivo && input.checked;
          var card = input.closest('[data-dispositivo-card]');
          if (card) card.classList.toggle('is-selected', !!input.checked);

          var wrap = card ? card.querySelector('[data-dispositivo-qty-wrap]') : null;
          if (wrap) wrap.hidden = !input.checked;

          var qtyInput = this.dispositivoQtyInput(input);
          if (qtyInput) {
            qtyInput.disabled = !active;
            qtyInput.required = !!active;
          }
        }
      }

      /*
       * El dispositivo se cotiza aparte de los regalos corporativos: unidades
       * más formato (kit completo o sólo el dispositivo).
       */
      dispositivoLine() {
        if (!this.quiere('dispositivo')) return null;

        var elegido = null;
        for (var i = 0; i < this.dispositivoInputs.length && !elegido; i++) {
          if (this.dispositivoInputs[i].checked) elegido = this.dispositivoInputs[i];
        }
        if (!elegido) return null;

        var qtyInput = this.dispositivoQtyInput(elegido);
        var qty = parseInt(qtyInput && qtyInput.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;

        var line = { title: this.dispositivoTitle, details: [], amount: null };
        line.details.push(qty ? qty + ' uds' : 'indica el nº de unidades');
        line.details.push(elegido.value);

        if (this.showPrices && qty) {
          var tiers = parseTiers(elegido.dataset.tiers);
          if (!tiers.length) tiers = this.dispositivoTiers;
          var tier = tierFor(tiers, qty);
          if (tier) line.amount = roundToTen(tier.price * qty);
        }
        return line;
      }

      /* Tarjeta contenedora de un regalo y su control de cantidad */
      giftCard(input) {
        return input.closest('[data-gift]');
      }

      giftQtyInput(input) {
        var card = this.giftCard(input);
        return card ? card.querySelector('[data-gift-qty-input]') : null;
      }

      /*
       * Muestra u oculta la cantidad de cada regalo según esté marcado, y la
       * desactiva cuando no aplica para que no viaje vacía en el email ni
       * bloquee el envío con su «required».
       */
      syncGifts(wantsRegalo) {
        for (var i = 0; i < this.regaloInputs.length; i++) {
          var input = this.regaloInputs[i];
          var active = wantsRegalo && input.checked;
          var card = this.giftCard(input);
          if (card) card.classList.toggle('is-selected', !!input.checked);

          var wrap = card ? card.querySelector('[data-gift-qty]') : null;
          if (wrap) wrap.hidden = !input.checked;

          var qtyInput = this.giftQtyInput(input);
          if (qtyInput) {
            qtyInput.disabled = !active;
            qtyInput.required = !!active;
          }
        }
      }

      /* Una línea por regalo seleccionado, cada uno con su propia cantidad */
      regaloLines() {
        if (!this.quiere('regalos')) return [];

        var lines = [];
        for (var i = 0; i < this.regaloInputs.length; i++) {
          var input = this.regaloInputs[i];
          if (!input.checked) continue;

          var line = { title: input.value, details: [], amount: null };
          var qtyInput = this.giftQtyInput(input);

          var qty = parseInt(qtyInput && qtyInput.value, 10);
          if (isNaN(qty) || qty < 0) qty = 0;

          if (input.dataset.mode === 'packs') {
            // Se envía en bolsas cerradas: se redondea a la bolsa que cubre el pedido
            var packs = parsePacks(input.dataset.packs);
            if (!qty) {
              line.details.push('indica el nº de unidades');
            } else if (!packs.length) {
              line.details.push(qty + ' uds');
            } else {
              var pack = packFor(packs, qty);
              line.details.push(
                pack.qty > qty ? qty + ' uds · se cotizan ' + pack.qty : pack.qty + ' uds'
              );
              // Subtotal redondeado a la decena más cercana
              if (this.showPrices) line.amount = roundToTen(pack.price);
            }
            lines.push(line);
            continue;
          }

          var tiers = parseTiers(input.dataset.tiers);

          if (!qty) {
            line.details.push('indica el nº de unidades');
          } else {
            // Sin desglose de precio unitario: solo la cantidad
            line.details.push(qty + ' uds');
            if (this.showPrices && tiers.length) {
              var tier = tierFor(tiers, qty);
              // Subtotal redondeado a la decena más cercana
              line.amount = roundToTen(tier.price * qty);
            }
          }
          lines.push(line);
        }
        return lines;
      }

      update() {
        var wantsF = this.quiere('formacion');
        var wantsD = this.quiere('dispositivo');
        var wantsR = this.quiere('regalos');

        // Primero abrimos o cerramos los pasos: al abrirse reactivan todos sus
        // campos, y los ajustes finos de abajo vuelven a afinar cuáles aplican.
        var self = this;
        this.steps.forEach(function (step) {
          self.setStepActive(step, self.quiere(step.dataset.stepFor));
        });

        this.syncInteres();
        this.syncFormaciones(wantsF);
        this.syncDispositivo(wantsD);
        this.syncGifts(wantsR);
        this.syncReferral();

        // La modalidad online tiene precio fijo: el nº de asistentes es informativo
        var isOnline = this.checkedValue(this.modalidadInputs) === 'online';
        if (this.asistentesField) {
          this.asistentesField.classList.toggle('is-informative', isOnline);
        }

        var lines = [];
        var formacion = this.formacionLine();
        if (formacion) lines.push(formacion);
        var dispositivo = this.dispositivoLine();
        if (dispositivo) lines.push(dispositivo);
        lines = lines.concat(this.regaloLines());

        var total = 0;
        var hasPending = false;
        if (this.showPrices) {
          lines.forEach(function (l) {
            if (typeof l.amount === 'number') total += l.amount;
            else hasPending = true;
          });
        }

        this.render(lines, total, hasPending);
      }

      render(lines, total, hasPending) {
        if (this.emptyEl) this.emptyEl.hidden = lines.length > 0;
        if (this.linesEl) {
          this.linesEl.innerHTML = '';
          var self = this;
          lines.forEach(function (line) {
            var row = document.createElement('li');
            row.className = 'palpa-cotizador__line';

            var label = document.createElement('div');
            label.className = 'palpa-cotizador__line-label';
            var title = document.createElement('span');
            title.className = 'palpa-cotizador__line-title';
            title.textContent = line.title;
            label.appendChild(title);
            (line.details || []).forEach(function (text) {
              if (!text) return;
              var detail = document.createElement('span');
              detail.className = 'palpa-cotizador__line-detail';
              detail.textContent = text;
              label.appendChild(detail);
            });

            row.appendChild(label);

            // Sin precios el resumen es sólo el listado de lo solicitado
            if (self.showPrices) {
              var amount = document.createElement('span');
              amount.className = 'palpa-cotizador__line-amount';
              amount.textContent =
                typeof line.amount === 'number' ? self.approx(line.amount) : self.consultLabel;
              row.appendChild(amount);
            }

            self.linesEl.appendChild(row);
          });
        }

        if (this.totalEl) {
          this.totalEl.textContent = lines.length ? this.approx(total) : this.approx(0);
        }
        this.classList.toggle('has-pending', hasPending);

        // Vuelca el resumen en el campo oculto que viaja en el email
        var text = lines
          .map(function (l) {
            var detalle = (l.details || []).filter(Boolean).join(' · ');
            var fila = '• ' + l.title + (detalle ? ' (' + detalle + ')' : '');
            if (!this.showPrices) return fila;
            var amount =
              typeof l.amount === 'number' ? this.approx(l.amount) : this.consultLabel;
            return fila + ' — ' + amount;
          }, this)
          .join('\n');
        if (this.hiddenSummary) {
          this.hiddenSummary.value = text || 'Sin selección';
        }
        if (this.hiddenTotal) {
          this.hiddenTotal.value =
            this.approx(lines.length ? total : 0) +
            (hasPending ? ' (+ conceptos a consultar)' : '');
        }
      }
    }
  );
})();
